"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVersion = void 0;
var setVersion_1 = require("./setVersion");
Object.defineProperty(exports, "setVersion", { enumerable: true, get: function () { return setVersion_1.setVersion; } });
(0, setVersion_1.setVersion)('@fluentui/set-version', '6.0.0');
//# sourceMappingURL=index.js.map